module.exports = __webpack_public_path__ + "media/images/camera_pause_red-64d1e66c2b736a882f6cf5bbd0bf6602610ae401afab32a3924ad4a192b38f2a.svg";